/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdatePreferredPharmacyErrorResponse,
  UpdatePreferredPharmacyRequest,
  UpdatePreferredPharmacyResponse,
} from './api.schemas';

import { api } from '../util/http';

export const updateEncountersPreferencesPharmacy = (
  encounterId: number,
  updatePreferredPharmacyRequest: UpdatePreferredPharmacyRequest,
) => {
  return api<UpdatePreferredPharmacyResponse>({
    url: `/api/encounters/${encounterId}/preferences/pharmacy`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updatePreferredPharmacyRequest,
  });
};

export const getUpdateEncountersPreferencesPharmacyMutationOptions = <
  TError = UpdatePreferredPharmacyErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEncountersPreferencesPharmacy>>,
    TError,
    { encounterId: number; data: UpdatePreferredPharmacyRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEncountersPreferencesPharmacy>>,
  TError,
  { encounterId: number; data: UpdatePreferredPharmacyRequest },
  TContext
> => {
  const mutationKey = ['updateEncountersPreferencesPharmacy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEncountersPreferencesPharmacy>>,
    { encounterId: number; data: UpdatePreferredPharmacyRequest }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return updateEncountersPreferencesPharmacy(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEncountersPreferencesPharmacyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEncountersPreferencesPharmacy>>
>;
export type UpdateEncountersPreferencesPharmacyMutationBody = UpdatePreferredPharmacyRequest;
export type UpdateEncountersPreferencesPharmacyMutationError = UpdatePreferredPharmacyErrorResponse;

export const useUpdateEncountersPreferencesPharmacy = <
  TError = UpdatePreferredPharmacyErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEncountersPreferencesPharmacy>>,
      TError,
      { encounterId: number; data: UpdatePreferredPharmacyRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEncountersPreferencesPharmacy>>,
  TError,
  { encounterId: number; data: UpdatePreferredPharmacyRequest },
  TContext
> => {
  const mutationOptions = getUpdateEncountersPreferencesPharmacyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
